{
  "title": "ŞANS ÇARKI",
  "description": "Her gün şansını dene!",
  "available": "Bugünün ücretsiz çevirisi hazır!",
  "spin": "🎡 ÇEVİR",
  "spinning": "Çark dönüyor...",
  "winTitle": "Tebrikler!",
  "win": "{{amount}} AZN bonus kazandınız!",
  "used": "🎁 Bugünün çevirisini kullandınız! Yarın tekrar gelin!",
  "homeCta": "Çarka dokunup şansını dene",
  "homeUsed": "Yarın tekrar gelin!",
  "ribbonReady": "ŞANSINI DENE",
  "ribbonUsed": "YARIN TEKRAR GEL",
  "hubSpin": "ÇEVİR",
  "sheetHint": "Çarka dokunup şansını dene",
  "winAmount": "{{amount}} AZN KAZANDINIZ!",
  "closeResult": "Kapat",
  "demoBadge": "Görsel demo — gerçek bonus yüklemeleri henüz aktif değil",
  "loginRequiredBadge": "Gerçek bonus almak için giriş yapın",
  "loginRequired": "Gerçek Şans Çarkını kullanmak için giriş yapın.",
  "demoWinNote": "Bu yalnızca görsel bir sonuçtur. Bonus bakiyesine yükleme yapılmadı.",
  "testBadge": "SİTE TEST MODU — TEST BONUSU, çekilemez",
  "testWinNote": "{{amount}} AZN TEST BONUSU yüklendi. Bu tutar çekilemez ve gerçek para bakiyesine eklenmez.",
  "testBalance": "Test bonusu",
  "testLedger": "TEST BONUSU (çekilemez)",
  "testNotWithdrawable": "Test bakiyesi asla çekilemez",
  "testExpires": "Test yüklemesinin süresi: {{when}}",
  "testPrize": "Test ödülü: {{amount}} AZN",
  "mute": "Sesi kapat",
  "unmute": "Sesi aç",
  "close": "Kapat",
  "openAria": "VBB Şans Çarkını aç",
  "spinFailed": "Çeviri başlatılamadı. Lütfen kısa süre sonra tekrar deneyin.",
  "wageringTitle": "Bonus çevrimi",
  "bonusBalance": "Bonus bakiye",
  "wageringMultiplier": "Gereksinim",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Çevrim hedefi",
  "wageringCompleted": "Tamamlanan",
  "wageringRemaining": "Kalan",
  "bonusStatus": "Bonus durumu",
  "withdrawalEligibility": "Çekim",
  "bonusNotWithdrawable": "Bonus bakiyesi, dönüşüm onaylanana kadar çekilemez"
}
